import { gql } from '@apollo/client';
import { CONFIG_ITEM_FRAGMENT } from './config-model.gql';

export const GET_USER_IDENTITY = gql`
  query GetUserIdentity($userId: String!) {
    im {
      user(userId: $userId) {
        userId
        emailVerified
        emailAddress
        dateCreated
        totpRequired
      }
      identity {
        ...IdentityManagementIdentity
      }
      configItems(keys: []) {
        ...ConfigItem
      }
    }
    vm {
      profile(userId: $userId) {
        profileId
        firstName
        lastName
        preferredName
        avatarUrl
        statusEmoji
        statusText
        userPreference {
          userPreferenceId
          rosterView
          calendarViewType
        }
        volunteer {
          activityEnrolments {
            activityEnrolmentId
            position
          }
        }
      }
      identity {
        ...VolunteerManagementIdentity
      }
      configItems(keys: ["prevent-volunteer-reports", "prevent-volunteer-add-others-in-reports", "prevent-volunteer-availability-submission", "allow-unavailability-and-leave", "see-rostered-dates-only", "operations-assigned-rostering-view", "allow-roster-comments", "show-capacity-status", "block-full-session-availability", "application-availability-complex", "allow-volunteer-activity-cancellation", "allow-backup-sessions", "prevent-overlapping-sessions", "require-tasks-before-joining", "hide-report-attendance", "prefill-report-attendance", "require-date-of-birth"]) {
        ...ConfigItem
      }
      # todo: set-up-your-profile ???
      application(userId: $userId) {
        applicationId
        # hasContractPrereqs
      }
      enforceTOTP
      enterpriseSubLockStructures
    }
  }

  fragment IdentityManagementIdentity on IDENTITY_IdentityManagementIdentityType {
    userId
    globalRoles {
      ...PrivilegeRole
    }
  }

  fragment VolunteerManagementIdentity on VOLUNTEER_VolunteerManagementIdentityType {
    userId
    managerIdentity {
      ...ManagerIdentity
    }
    volunteerIdentity {
      ...VolunteerIdentity
    }
    applicantIdentity {
      ...ApplicantIdentity
    }
    globalRoles {
      ...PrivilegeRole
    }
  }

  fragment ManagerIdentity on VOLUNTEER_ManagerIdentityType {
    managerId
    programManagerIdentities {
      programId
      role {
        ...PrivilegeRole
      }
    }
  }

  fragment VolunteerIdentity on VOLUNTEER_VolunteerIdentityType {
    volunteerId
    programIdentities {
      ...ProgramIdentity
    }
    dateCreated
  }

  fragment ProgramIdentity on VOLUNTEER_ProgramIdentityType {
    programId
    activityIds
    ledActivityIds
  }

  fragment ApplicantIdentity on VOLUNTEER_ApplicantIdentityType {
    applicationId
  }

  fragment PrivilegeRole on PrivilegeRoleType {
    privilegeRoleId
    name
    ruleKeys
  }

  ${CONFIG_ITEM_FRAGMENT}
`;
